import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/vessels`);
  },

  fetchDetail(portId, vesselId) {
    return http.get(`${resource}/${portId}/vessels/${vesselId}`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/vessels/${itemId}`, payload);
  },

  search(portId, payload) {
    return http.get(`${resource}/${portId}/vessels/search`, { params: payload });
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/vessels`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/vessels/${itemId}`);
  },
};
